import React from "react";
import axios from "axios";
import ReactTable from "react-table";
import {connect} from 'react-redux';
import {Tooltip, OverlayTrigger, Grid, Row, Col, FormGroup, InputGroup} from 'react-bootstrap';
import Button from "../CustomButton/CustomButton.jsx";
import moment from 'moment';
import {withNamespaces} from "react-i18next";
import {ModalViewTvGuideProgram} from "../CustomModals/ModalViewTvGuideProgram";
import {userActions} from "../../authentication/_actions";
import Card from "../Card/Card";

class DataTvGuideStatic extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

            info_tooltip: (<Tooltip id="info_tooltip">Info</Tooltip>),

            program_id: null,
            loading: false,
            guideArray: [],
            columns: [],
            data: [],
            showModalTvGuide: false,

            sorted: [],
            filtered: [],

            pages: null,
            page: 1,
            pageSize: 10,

            lastUpdate: null,
            filter: "",
            searchTvGuideAll: ""

        };
    }

    loadColumnsTvGuide() {

        this.setState({
            columns: [
                {
                    accessor: "static_epg_id",
                    Header: "ID",
                    maxWidth: 50,
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "static_epg_channel_id",
                    Header: "Channel ID",
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "static_epg_channel_name",
                    Header: "Name",
                    sortable: false,
                    filterable: false
                },

                {
                    accessor: "static_epg_title",
                    Header: "Title",
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "static_epg_description",
                    Header: "Description",
                    sortable: true,
                    filterable: false,
                },
                {
                    accessor: "static_epg_duration",
                    Header: "Duration",
                    sortable: true,
                    filterable: false,
                },
                {
                    accessor: "static_epg_id",
                    Header: "More Info",
                    maxWidth: 80,
                    sortable: false,
                    filterable: false,
                    Cell: row => (
                        <div className="actions-right">
                            {this.setHelperButton(row.value)}
                        </div>
                    )
                }]
        })
    }

    //BUTTONS
    setHelperButton(program_id) {

        return (<OverlayTrigger placement="top" overlay={this.state.info_tooltip}>
            <Button
                onClick={() => {
                    this.setState({
                        program_id: program_id,
                        showModalTvGuide: true,
                    })
                }}

                bsStyle="info"
                simple
                icon
            >
                <i className="fa fa-info"/>
            </Button>
        </OverlayTrigger>)

    }

    loadImage(value) {

        if (value === null || value === undefined || value === '' || value === 'comp_') {
            let image = process.env.REACT_APP_ASSET_URL + "/global/poster_image_empty.png"
            return image;
        } else {
            // let image = process.env.REACT_APP_ASSET_URL + "/live_tv/" + value
            return value;
        }

    }

    componentDidMount() {
        this.getTvGuideStaticData();
    }

    getTvGuideStaticData() {

        this.loadColumnsTvGuide();

        this.setState({
            loading: true
        })

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json',
            }
        };

        let dataUrl = process.env.REACT_APP_API_URL + "/TvGuide/static";

        axios.get(dataUrl, axiosConfig)
            .then((res) => {
                const guideArray = res.data;
                const loading = false;
                this.setState({guideArray, loading});
            })
            .catch(error => {
                this.setState({loading: false});
                console.log(error);
            });

    }

    renderViewTvGuideProgram = () => {

        if (this.state.showModalTvGuide) {
            return <ModalViewTvGuideProgram
                headerMessage={"View Program Info"}
                bodyMessage={""}
                handlerFromParent={this.setViewTvGuideStaticProgramModal}
                programId={this.state.program_id}
            />
        }
    }

    setViewTvGuideStaticProgramModal = (value, action) => {

        this.setState({
            showModalTvGuide: value
        })

    }

    render() {
        return (
            <div>
                {this.renderViewTvGuideProgram()}
                <Card
                    content={
                        <div>
                            <ReactTable
                                data={this.state.guideArray}
                                filterable
                                loading={this.state.loading}
                                columns={this.state.columns}
                                defaultPageSize={10}
                                showPaginationBottom
                                className="-striped -highlight"
                            />
                        </div>
                    }
                />
            </div>
        );

    }
}


function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDataTvGuideStatic = connect(mapStateToProps)(DataTvGuideStatic);
const connectedDataTvGuideStaticTrans = withNamespaces('common')(connectedDataTvGuideStatic);
export {connectedDataTvGuideStaticTrans as DataTvGuideStatic};